module.exports = __webpack_public_path__ + "static/img/easy@3x.8e81bc30.png";